// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1aPK5","content":"styles_content__2DCmv","selectAll":"styles_selectAll__1sn8i"};